// extracted by mini-css-extract-plugin
export default {"container":"PrimaryAndSecondaryButtonContainerForModal_container__7Lcuj"};